import { Box, makeStyles } from '@material-ui/core';
import MOON_IMG from './images/moon.svg';
import SUN_IMG from './images/sun.svg';

const useStyles = makeStyles((theme) => ({
  checkbox: { opacity: 0, position: 'absolute' },
  checkboxLabel: {
    backgroundColor: (props) => (props.mode === 'dark' ? '#191826' : '#FFFFFF'),
    width: '62px',
    height: '26px',
    borderRadius: '50px',
    position: 'relative',
    padding: '5px',
    cursor: 'pointer',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    transition: 'background-color 0.2s linear',
  },
  sun: {
    padding: 8,
    zIndex: 10,
  },
  moon: {
    padding: 8,
    zIndex: 10,
  },
  ball: {
    background: (props) => (props.mode === 'light' ? '#0F0F0F' : '#FFFFFF'),
    borderRadius: '100%',
    height: 32,
    width: 32,
    position: 'absolute',
    transform: (props) =>
      `translate(${props.mode === 'dark' ? '32px' : 0}, 0px)`,
    transition: 'transform 0.4s linear',
  },
}));

export const ThemeModeSwitch = ({ mode = 'light', setMode }) => {
  const classes = useStyles({ mode });

  return (
    <Box padding={'0 48px 0 0'}>
      <input
        type="checkbox"
        className={classes.checkbox}
        id="checkbox"
        onChange={setMode}
      />
      <label for="checkbox" className={classes.checkboxLabel}>
        <img src={SUN_IMG} className={[classes.sun]} alt="Light mode" />
        <img src={MOON_IMG} className={classes.moon} alt="Dark mode" />
        <div className={classes.ball} />
      </label>
    </Box>
  );
};
